<div style="display: flex; justify-content: space-between; align-items: center;">
  <div>
    {{data.message}}
  </div>
  <div style="align-self: center;">
    <button mat-icon-button
            (click)="ref.dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
